import React, { useEffect, useState } from "react";

import { Banner } from "~/components/ui/banner";
import { useSupabaseSession } from "~/context/SupabaseSessionContext";
import { hasUserMadeConsentChoice, setAnalyticsConsent } from "~/lib/analytics";

// AIDEV-NOTE: Keep name/path neutral so Safari content blockers don't suppress the module request
export const PolicyBanner: React.FC<{
    defaultOpen?: boolean;
    onClose?: () => void;
}> = ({ defaultOpen = false, onClose }) => {
    const [showBanner, setShowBanner] = useState(defaultOpen);
    const { session } = useSupabaseSession();

    useEffect(() => {
        const hasChoice = hasUserMadeConsentChoice();
        if (!hasChoice) {
            setShowBanner(true);
        }
    }, []);

    const handleAcceptAll = () => {
        setAnalyticsConsent(true, session?.user || null);
        setShowBanner(false);
        onClose?.();
    };

    const handleEssentialOnly = () => {
        setAnalyticsConsent(false, session?.user || null);
        setShowBanner(false);
        onClose?.();
    };

    if (!showBanner) return null;

    return (
        <Banner
            title="We value your privacy"
            description={
                <>
                    We use analytics to understand how to make this{" "}
                    <strong>free service</strong> more valuable for our users.{" "}
                    <a
                        href="/privacy"
                        className="underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        See our Privacy Policy
                    </a>{" "}
                    for more information.
                </>
            }
            variant="cream"
            primaryAction={{
                label: "Accept",
                onClick: handleAcceptAll,
            }}
            secondaryAction={{
                label: "Reject",
                onClick: handleEssentialOnly,
            }}
        />
    );
};
